module.exports = __webpack_public_path__ + "static/img/error-research.872504a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/error-research.png
// module id = bWiV
// module chunks = 1